export default __webpack_public_path__ + "static/media/integration_img.e8fb2c5a.png";